import appConfig from "../../../app-config";
import ApiService from "../api.service";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const MaterialIssuesService = {
    dataSourceConfig(url, params) {
        return ApiService.createDataSource(url, params);
    },

    async getMaterialIssueHeader(Code) {
        const requestScreenData = {
            url: `api/MaterialIssue`,
            filter: `Code eq ${Code}`,
            // select: ["BranchCode", "UnitOfMeasureCode", "ProductCode", "ConversionFactor"],
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async getDefaultIssueType(WorkOrderInstance) {
        const requestScreenData = {
            url: `api/ActiveMaterialIssueType`,
            filter: `IsEnabled eq 'Y' and IsDefault eq 'Y'`,
        };

        if (WorkOrderInstance && WorkOrderInstance !== 'Core') {
            requestScreenData.filter += ` and WorkOrderInstance eq '${WorkOrderInstance}'`;
        }

        return await ApiService.oDataGet(requestScreenData);
    },

    async reverseMaterialIssue(payload) {
        const url = "api/MaterialIssue/Reverse";

        return await ApiService.post(url, payload);
    },

    async AlmondcoDistinctCardNo(CardNo, SeasonYear) {
        const requestScreenData = {
            url: `api/AlmondcoDistinctCardNo`,
            filter: `CardNo eq ${CardNo}`,
        }


        if (SeasonYear) {
            requestScreenData.filter += ` and SeasonYear eq ${SeasonYear}`;
        }

        return await ApiService.oDataGet(requestScreenData);
    },

    async getAllBatchNo(getFilter, params, BranchCode) {
        var filter = `(SourceTransactionType eq '') and (SourceTransactionNo eq 0) and (SourceTransactionLine eq 0) and (SourceTransactionProcessCode eq '')`;
        if (getFilter) {
            filter = filter + ` and (${getFilter})`;
        }

        if (BranchCode) filter += ` and BranchCode eq '${BranchCode}'`;
        const requestScreenData = {
            url: "api/ConsumeProductBatch",
            filter: filter,
        };
        if (params) {
            if (params.select) {
                requestScreenData.select = params.select;
            }
        }

        return await ApiService.oDataGet(requestScreenData);
    },

    async saveMaterialIssue(data) {
        return await ApiService.post("api/Save_MaterialIssue", data);
    },

    async getMaterialIssueFooterTotals(IssueFilter) {
        const requestScreenData = {
            url: `api/MaterialIssueDetailGrouped?${IssueFilter}`,
        };

        return await ApiService.oDataGet(requestScreenData);
    }

}

export { MaterialIssuesService }